import { post , get } from '../axiosconfig'
import qs from 'qs'
export default {
  // 获取轮播图
  getCarousel(params){
    params = qs.stringify(params)
    return get('/zsc/web/home/show/carousels', params)
  },

  // 租用价格
  zyTemplates(params) {
    params = qs.stringify(params)
    return get('/zsc/web/activity/package/templates', params)
  },

  // 算力排名
  getranking(params) {
    params = qs.stringify(params)
    return get('/zsc/web/power/ranking', params)
  },

  // 合作伙伴
  getPartnerall(params) {
    params = qs.stringify(params)
    return get('/zsc/web/partner/all', params)
  },
  // 产品动态
  getNewlist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/product/news/list', params)
  },

  // 优惠活动专区
  getActivitylist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/activity/list', params)
  },

  // 活动优惠券列表
  getPackagelist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/activity/coupon/list', params)
  },
  // 活动套餐折扣列表+满减列表
  getDiscountlist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/activity/package/list', params)
  },
  // 活动优惠商品列表
  getDiscountProductslist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/activity/coupon/templates', params)
  },
  // 活动优惠券领取
  couponCollection(params) {
    return post('/zsc/web/console/coupon/receive', params)
  },
  // 消息中心
  getNews(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/notify/list', params)
  },
  // 消息清空
  messageClearing(params) {
    return post('/zsc/web/console/notify/clean', params)
  },
  // 优惠券列表
  getCoupon(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/coupon/list', params)
  },
  // 优惠券列表
  getCouponJson(params) {
    const options = { arrayFormat: 'brackets',encode: false }
    params = qs.stringify(params, options)
    return get('/zsc/web/console/coupon/list', params)
  },
  // 代金券激活
  couponCash(params) {
    return post('/zsc/web/console/coupon/cash', params)
  },
  // 兑换码
  sendExchange(params) {
    return post('/zsc/web/console/coupon/exchange', params)
  },
  // 获取图形验证码
  getCaptcha(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/user/captcha', params)
  },
  
  // 发送短信验证码
  sendVCode(params) {
    return post('/zsc/web/console/user/send_verification_code', params)
  },

  // 注册
  sendRegister(params) {
    return post('/zsc/web/console/user/register', params)
  },

  // 官网通知
  webNotice(params) {
    params = qs.stringify(params)
    return get('/zsc/web/home/notice', params)
  },
  // 官网通知
  ctrlNotice(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/notice', params)
  },

}


// WEBPACK FOOTER //
// ./src/api/public/website_api.js